import { useSearchParams } from 'react-router-dom';
import { Icon } from '../../../shared';
import infoIcon from '../checkout/user-data-information-box/information-icon.svg?url';

import { FCC } from '~/utils/types';
import { PROVIDER_SELECTION_HEADING_ID } from './VerificationProviderSelection';
import './verification.scss';

export const VerificationStep: FCC<{
  showMustSelectProvider: boolean;
  providerName: string;
  children: React.ReactNode;
}> = ({ showMustSelectProvider, providerName, children }) => {
  const [searchParams] = useSearchParams();
  const restartRequired = searchParams.get('restartRequired');
  return (
    <div className="verification card">
      {restartRequired && (
        <span style={{ color: 'red' }}>
          Det ser ut til at noe gikk galt da du prøvde å verifisere deg selv. Vennligst prøv igjen.
          <br />
          <br />
        </span>
      )}
      {showMustSelectProvider && (
        <span style={{ color: 'red', display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '40px' }}>
          <Icon type="alertCircleBold" fill="red" />
          Du må identifisere deg for å fullføre registreringen.
        </span>
      )}
      <h2 className="title-3" id={PROVIDER_SELECTION_HEADING_ID}>
        Velg en identifiseringsmåte
      </h2>
      <div>
        <div className="identification-information-text">
          <div style={{ marginBottom: '12px' }}>
            Gjør bestillingen din tryggere og sikrere ved å identifisere deg med Vipps eller BankID. Slik kan vi bekrefte at det er deg som
            gjennomfører kjøpet. Har du ikke Vipps eller BankID ta{' '}
            <a href="https://www.rikstv.no/kontakt" style={{ color: 'black' }}>
              kontakt med kundeservice
            </a>
            .
          </div>
          <span>
            RiksTV beholder opplysningene dine for å gjøre registreringen sikrere. Les mer i vår{' '}
            <a href="https://www.rikstv.no/personvern" target="_blank" style={{ color: 'black' }} rel="noreferrer">
              personvernerklæring
            </a>
            .
          </span>
        </div>
        <div className="vipps-container" style={{ marginBottom: '12px' }}>
          {/* VerificationProviderSelection */}
          {children}
        </div>
        {providerName !== '' && (
          <div>
            <img className="info-icon" src={infoIcon} alt="" />
            <span>Etter å ha klikket på “Neste”, blir du sendt til {providerName} for å identifisere deg.</span>
          </div>
        )}
      </div>
    </div>
  );
};
